export const documentKeys = {
  accountDocuments: ['account-documents'] as const,
}
